import { Component } from '@angular/core';

@Component({
  selector: 'app-gesture-intro-overlay',
  standalone: true,
  imports: [],
  templateUrl: './gesture-intro-overlay.component.html',
  styleUrls: ['./gesture-intro-overlay.component.scss']
})
export class GestureIntroOverlayComponent {
}
